import { RestSchemas } from '@/contexts/QueryProvider'
import { DataAssetSummaryResponse } from '../DataAssetsV2/useGetDataAssets'

type TemplateSummaryResponse = RestSchemas['Messages.Templates.TTemplateActivity']

export function groupTemplateItems(data: TemplateSummaryResponse[]) {
  // const data = mockData
  const groupedByEntityType: Record<string, TemplateSummaryResponse[]> = {}

  data.forEach((item) => {
    const entityTypeName = item.entity.entity_type.name
    if (!groupedByEntityType[entityTypeName]) {
      groupedByEntityType[entityTypeName] = []
    }
    groupedByEntityType[entityTypeName].push(item)
  })

  return {
    items: Object.entries(groupedByEntityType).map(([groupName, groupItems]) => {
      const groupedByEntityName: Record<string, TemplateSummaryResponse[]> = {}

      groupItems.forEach((item) => {
        const entityName = item.entity.name
        if (!groupedByEntityName[entityName]) {
          groupedByEntityName[entityName] = []
        }
        groupedByEntityName[entityName].push(item)
      })

      const subgroups = Object.entries(groupedByEntityName).map(([name, items]) => ({
        name,
        items,
      }))

      return {
        groupName,
        items: subgroups,
      }
    }),
    allTemplates: data,
  }
}

/**
 * Filters template items based on state and search criteria
 */
export const filterTemplates = (
  summary: TemplateSummaryResponse[] | undefined,
  filter: string,
  search: string
): TemplateSummaryResponse[] => {
  if (!summary) return []

  return summary.filter((item) => {
    // Apply state filter
    const stateMatches = filter === 'All' || item.state === filter

    // Apply search filter if search string exists
    if (!search) return stateMatches

    const searchLower = search.toLowerCase()
    const templateNameMatches = item.file_template?.name?.toLowerCase().includes(searchLower) || false
    const fileNameMatches = item.file_name?.toLowerCase().includes(searchLower) || false

    return stateMatches && (templateNameMatches || fileNameMatches)
  })
}
